module.exports = __webpack_public_path__ + "img/Itau.740ad30d.png";